import React from "react";
import { Card, Divider } from "antd";
import { FaClock, FaMapMarkerAlt, FaCheck } from "react-icons/fa";
import { LucideCircleCheck } from "lucide-react";


const LeaveCard = ({ name, location, type, fromDate, toDate, days, status }) => {
  return (


    <Card className="rounded-2xl border-2 border-slate-300 hover:shadow-lg overflow-y-auto space-y-4 pr-2 mb-2 hover:shadow-l">
      <div className="flex justify-between items-start">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 text-gray-700 font-semibold">
              {(name ? name.split(" ").map((n) => n[0]).join("") : "")}
          </div>
          <div>
            <h3 className="font-semibold text-gray-800">{name}</h3>
            <div className="flex items-center text-gray-600 text-sm">
              <FaMapMarkerAlt className="mr-1 text-gray-400" />
              {location}
            </div>
          </div>
        </div>
        <span
          className={`flex items-center text-xs border status-indicator ${type.toLowerCase().replace(" ", "-")}`}
        >
          {type}
        </span>
      </div>

 <Divider style={{ margin: "1rem 0", borderColor: "#e5e7eb" }} />


      <div className="flex justify-between items-center bg-gray-50 rounded-xl p-1 text-sm text-gray-700">
        <div className="flex-1 text-center">
          <p className="text-xs text-gray-500">FROM</p>
          <p className="font-semibold text-gray-900">{fromDate}</p>
        </div>
        <div className="flex-1 text-center border-l border-gray-200">
          <p className="text-xs text-gray-500">TO</p>
          <p className="font-semibold text-gray-900">{toDate}</p>
        </div>
      </div>

      <div className="flex justify-between items-center mt-4">
        <div className="flex items-center text-gray-500 text-sm">
          <FaClock className="mr-2 text-gray-500" />
          {days} days
        </div>

        <span
          className="status-indicator completed"
        >
          <div className="flex items-center text-xs gap-1">
            <LucideCircleCheck size={12}/>
            {status}
          </div>
        </span>
      </div>
    </Card>

  );
};

export default LeaveCard;

